<template>
  <b-modal title="Lista de Equipamentos" v-model="show" size="xl">
    <div class="modal-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE EQUIPAMENTOS :::::::::::::::::::::::::::: -->
      <b-table
        id="table-equip"
        bordered
        hover
        small
        head-variant="light"
        :per-page="perPage"
        :current-page="currentPage"
        :items="getFilterEquipamentos(filtro)"
        :fields="fields.equipamento"
      >
        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="display(data.item)">
              <b-icon icon="image" variant="info"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: MODAIS DE USO :::::::::::::::::::::::::::: -->
    <display-modal ref="display" :size="'sm'" />
    <cliente-list ref="clienteList" @addCliente="addCliente($event)" />

    <template #modal-footer>
      <b-form inline>
        <b-icon icon="search" variant="primary" scale="1.2" class="m-1" />
        <b-form-input
          id="eqp-filter-sgcq"
          type="search"
          size="sm"
          variant="warning"
          class="m-1 p-1"
          placeholder="Sgcq"
          v-model="filtro.sgcq"
        />
        <b-form-input
          id="eqp-filter-codigo"
          type="search"
          size="sm"
          class="m-1 p-1"
          placeholder="Código"
          v-model="filtro.codigo"
        />
        <b-form-input id="eqp-filter-nome" type="search" size="sm" class="m-1 p-1" placeholder="Nome" v-model="filtro.nome" />
        <b-form-input id="eqp-filter-grupo" type="search" size="sm" class="m-1 p-1" placeholder="Grupo" v-model="filtro.grupo" />
        <b-form-input
          id="eqp-filter-referencia"
          type="search"
          size="sm"
          class="m-1 p-1"
          placeholder="Referência"
          v-model="filtro.referencia"
        />
        <b-button id="max-size-cliente" class="ml-1 p-1 pl-3 pr-3" variant="primary" @click="$refs.clienteList.call()">
          {{ filtro.cliente.nome }}
        </b-button>
      </b-form>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useEquipamentoStore } from "@/stores/EquipamentoStore";
import TableFields from "@/tools/TableFields";
import DisplayModal from "@/components/modals/diversos/DisplayModal";
import ClienteListModal from "@/components/modals/cliente/ClienteListModal";
import Files from "@/http/files";
import Cliente from "@/models/Cliente";

export default {
  name: "EquipamentoListModal",

  data() {
    return {
      show: false,
      fields: new TableFields(),
      filtro: {
        sgcq: "",
        codigo: "",
        nome: "",
        grupo: "",
        referencia: "",
        cliente: new Cliente(0, "Todos os Clientes", "", "", "", "", "", "", ""),
      },
      files: new Files(this.$http),
      perPage: 50,
      currentPage: 1,
    };
  },

  components: {
    "display-modal": DisplayModal,
    "cliente-list": ClienteListModal,
  },

  computed: {
    rows() {
      return this.getFilterEquipamentos(this.filtro).length;
    },
  },

  methods: {
    display(equipamento) {
      this.files.downloadEquipamento(equipamento.sgcq).then((response) => this.$refs.display.call(response));
    },

    addCliente(cliente) {
      this.filtro.cliente.update(cliente);
    },

    call() {
      this.show = !this.show;
    },
  },

  setup() {
    const store = useSgcqStore();
    const equipamentoStore = useEquipamentoStore();
    const { getFilterEquipamentos } = storeToRefs(equipamentoStore);

    return {
      store,
      equipamentoStore,
      getFilterEquipamentos,
    };
  },
};
</script>

<style lang="scss" scoped>
#eqp-filter-sgcq {
  width: 4rem;
}
#eqp-filter-codigo {
  width: 6rem;
}
#eqp-filter-nome {
  width: 18rem;
}
#eqp-filter-grupo {
  width: 8rem;
}
#eqp-filter-referencia {
  width: 10rem;
}
#max-size-cliente {
  max-width: 12rem;
  max-height: 2rem;
  overflow-x: hidden;
}
</style>
